<template>
  <div class="row bg-secondary-13">
    <div class="col-12 mt-3">
      <em class="icon-shadowed fas fa-history text-orange" />
      <span class="color-gray-7 font-16 font-weight-bold ml-2 mb-2">
        Historial de Bitácora
      </span>
    </div>

    <div v-for="blog in limitedBlogItems" :key="blog.id" class="col-12">
      <BitacoraResultRow
        :academic-year="blog.academicYearText"
        :comment="blog.comment"
        :date="blog.date"
        :file-alias="blog.fileAlias"
        :file-id="blog.fileId"
        :filename="blog.filename"
        :status-color="blog.statusColor"
        :status-name="blog.statusName"
        :user="blog.user"
        @download="$emit('download', $event)"
      />
    </div>
    <div
      v-if="showButtonShowMore"
      class="container-fluid d-flex justify-content-center"
    >
      <action-button
        class="m-4 pr-5 pl-3 mx-auto outline rounded-pill"
        i="fas fa-angle-down pr-2"
        text="Ver más"
        variant="outline-success"
        @click="showMore = true"
      />
    </div>
  </div>
</template>

<script>
import { BitacoraResultRow } from '@quisit/bitacora';
import ActionButton from 'ActionButton';

export default {
  name: 'BitacoraHistory',
  components: {
    ActionButton,
    BitacoraResultRow,
  },
  props: {
    blogItems: {
      type: Array,
      default: () => [],
    },
    initialMaxPreview: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      showMore: false,
    };
  },
  computed: {
    showButtonShowMore() {
      return this.blogItems.length > this.initialMaxPreview && !this.showMore;
    },
    limitedBlogItems() {
      return this.showMore
        ? this.blogItems
        : this.blogItems.slice(0, this.initialMaxPreview);
    },
  },
  mounted() {
    this.$emit('load-bitacora');
  },
};
</script>

<style scoped lang="scss">
.icon-shadowed {
  padding: 8px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #fff 0 0 no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
}
</style>
